import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from './modules/auth'
import errors from './modules/errors'
import languages from './modules/languages'
import youtube from './modules/youtube'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true,

  modules: {
    auth,
    errors,
    languages,
    youtube
  }
})



// WEBPACK FOOTER //
// ./src/vuex/store.js